import { render, staticRenderFns } from "./ListDelivery.vue?vue&type=template&id=25741130&scoped=true&"
import script from "./ListDelivery.vue?vue&type=script&lang=ts&"
export * from "./ListDelivery.vue?vue&type=script&lang=ts&"
import style0 from "./ListDelivery.vue?vue&type=style&index=0&id=25741130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25741130",
  null
  
)

export default component.exports